<section class="content">
  <div class="content-block">
    <div class="card p-0">
      <div class="manuel-wrapper">

        <!-- ── Sidebar ── -->
        <nav class="manuel-nav">
          <div class="nav-header">
            <h5><i class="fa fa-book mr-1"></i> Manuel d'utilisation</h5>
          </div>
          <ul>
            <ng-container *ngFor="let s of sections; let i = index">
              <li *ngIf="i === 10" class="nav-divider"></li>
              <li>
                <a [class.active]="activeSection === s.id" (click)="setSection(s.id)">
                  <i class="fa {{s.icon}}"></i> {{ s.label }}
                </a>
              </li>
            </ng-container>
          </ul>
        </nav>

        <!-- ── Contenu ── -->
        <div class="manuel-content">

          <!-- ════════════════ INTRODUCTION ════════════════ -->
          <div *ngIf="activeSection === 'intro'">
            <div class="hero-banner">
              <i class="fa fa-shield-alt hero-icon"></i>
              <div>
                <h2>Medicalee — Gestion de l'assurance santé</h2>
                <p>Plateforme intégrée couvrant la production, les prestations médicales,
                  la comptabilité et le reporting. Ce manuel vous guide dans chaque module.</p>
              </div>
            </div>

            <p class="page-subtitle">Cliquez sur un module ci-dessous pour accéder directement à sa documentation.</p>

            <div class="module-pills">
              <span class="pill" *ngFor="let s of sections.slice(2, 10)" (click)="setSection(s.id)">
                <i class="fa {{s.icon}}"></i> {{ s.label }}
              </span>
            </div>

            <h3 class="sub-title"><i class="fa fa-map-signs"></i> Parcours recommandé</h3>
            <div class="workflow">
              <div class="wf-step">
                <div class="wf-num">1</div>
                <div class="wf-body">
                  <h6>Paramétrage initial</h6>
                  <p>Configurer la filiale, les modes de règlement, les barèmes, les polices et les prestataires.</p>
                </div>
              </div>
              <div class="wf-step">
                <div class="wf-num">2</div>
                <div class="wf-body">
                  <h6>Production</h6>
                  <p>Créer les contrats, enregistrer les bénéficiaires, émettre les quittances de prime.</p>
                </div>
              </div>
              <div class="wf-step">
                <div class="wf-num">3</div>
                <div class="wf-body">
                  <h6>Prestation & Médical</h6>
                  <p>Saisir les soins via le tiers payant, traiter les ententes préalables et les hospitalisations.</p>
                </div>
              </div>
              <div class="wf-step">
                <div class="wf-num">4</div>
                <div class="wf-body">
                  <h6>Sinistre</h6>
                  <p>Déclarer, instruire et valider les décomptes de sinistres.</p>
                </div>
              </div>
              <div class="wf-step">
                <div class="wf-num">5</div>
                <div class="wf-body">
                  <h6>Comptabilité</h6>
                  <p>Encaisser les primes et factures, gérer les ristournes et les mouvements comptables.</p>
                </div>
              </div>
              <div class="wf-step">
                <div class="wf-num">6</div>
                <div class="wf-body">
                  <h6>Éditique</h6>
                  <p>Générer les rapports, les états de dépenses et les résultats techniques.</p>
                </div>
              </div>
            </div>

            <h3 class="sub-title"><i class="fa fa-user-tag"></i> Profils utilisateurs</h3>
            <table class="manual-table">
              <thead>
                <tr>
                  <th>Profil</th>
                  <th>Modules accessibles</th>
                  <th>Actions principales</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td><strong>Administrateur</strong></td>
                  <td>Tous les modules</td>
                  <td>Gestion complète, paramétrage, rôles</td>
                </tr>
                <tr>
                  <td><strong>Gestionnaire production</strong></td>
                  <td>Paramètres, Production</td>
                  <td>Contrats, bénéficiaires, quittances</td>
                </tr>
                <tr>
                  <td><strong>Gestionnaire médical</strong></td>
                  <td>Prestation, Médical</td>
                  <td>Tiers payant, RD, hospitalisations</td>
                </tr>
                <tr>
                  <td><strong>Comptable</strong></td>
                  <td>Comptabilité, Éditique</td>
                  <td>Encaissements, règlements, états</td>
                </tr>
                <tr>
                  <td><strong>Médecin conseil</strong></td>
                  <td>Médical, Sinistre</td>
                  <td>Ententes préalables, validation décomptes</td>
                </tr>
                <tr>
                  <td><strong>Auditeur</strong></td>
                  <td>Audit, Éditique</td>
                  <td>Consultation uniquement, historiques</td>
                </tr>
              </tbody>
            </table>
          </div>

          <!-- ════════════════ PREMIERS PAS ════════════════ -->
          <div *ngIf="activeSection === 'premiers-pas'">
            <h1 class="page-title">Premiers pas</h1>
            <p class="page-subtitle">Tout ce qu'il faut savoir pour démarrer rapidement sur Medicalee.</p>

            <div class="callout info">
              <i class="fa fa-info-circle callout-icon"></i>
              <p><strong>Avant de commencer</strong>
                Assurez-vous que votre administrateur a créé votre compte et vous a transmis vos identifiants de connexion.</p>
            </div>

            <div class="step-card">
              <div class="card-head"><div class="step-num">1</div><h5>Se connecter</h5></div>
              <ol>
                <li>Ouvrez l'application dans votre navigateur</li>
                <li>Saisissez votre <strong>login</strong> et votre <strong>mot de passe</strong></li>
                <li>Cliquez sur <strong>Se connecter</strong></li>
                <li>Vous êtes redirigé vers le tableau de bord selon votre profil</li>
              </ol>
            </div>

            <div class="step-card">
              <div class="card-head"><div class="step-num">2</div><h5>Naviguer dans l'application</h5></div>
              <ul>
                <li>La <strong>barre latérale gauche</strong> contient tous les modules accessibles selon votre rôle</li>
                <li>Cliquez sur un menu parent pour développer ses sous-menus</li>
                <li>La <strong>barre supérieure</strong> affiche votre nom, des notifications et l'accès à votre profil</li>
              </ul>
            </div>

            <div class="step-card">
              <div class="card-head"><div class="step-num">3</div><h5>Modifier son mot de passe</h5></div>
              <ol>
                <li>Cliquez sur votre nom en haut à droite</li>
                <li>Sélectionnez <strong>Mon profil</strong></li>
                <li>Renseignez l'ancien mot de passe et le nouveau</li>
                <li>Confirmez et sauvegardez</li>
              </ol>
            </div>

            <div class="step-card">
              <div class="card-head"><div class="step-num">4</div><h5>Conventions de l'interface</h5></div>
              <table class="manual-table" style="margin-top:8px">
                <thead><tr><th>Élément</th><th>Signification</th></tr></thead>
                <tbody>
                  <tr><td><span style="color:#28a745">●</span> Vert</td><td>Actif, validé, réglé</td></tr>
                  <tr><td><span style="color:#ffc107">●</span> Orange</td><td>En attente, partiellement réglé</td></tr>
                  <tr><td><span style="color:#dc3545">●</span> Rouge</td><td>Inactif, rejeté, en retard</td></tr>
                  <tr><td><i class="fa fa-edit" style="color:#0665aa"></i> Crayon</td><td>Modifier l'élément</td></tr>
                  <tr><td><i class="fa fa-trash" style="color:#dc3545"></i> Corbeille</td><td>Supprimer l'élément</td></tr>
                  <tr><td><i class="fa fa-eye" style="color:#6c757d"></i> Œil</td><td>Consulter le détail</td></tr>
                </tbody>
              </table>
            </div>
          </div>

          <!-- ════════════════ PARAMÉTRAGE ════════════════ -->
          <div *ngIf="activeSection === 'parametrage'">
            <h1 class="page-title">Paramétrage</h1>
            <p class="page-subtitle">Le paramétrage est la fondation du système. Il doit être réalisé avant toute opération de production ou de comptabilité.</p>

            <div class="callout warning">
              <i class="fa fa-exclamation-triangle callout-icon"></i>
              <p><strong>Important :</strong> Un paramétrage incomplet (barème manquant, mode de règlement absent) bloquera les opérations de production et de comptabilité.</p>
            </div>

            <span class="section-tag"><i class="fa fa-globe"></i> Paramètres Système</span>

            <div class="step-card">
              <div class="card-head"><h5><i class="fa fa-building" style="color:#0665aa"></i> Paramètres globaux de la filiale</h5></div>
              <p>Définissez les informations de base de votre filiale :</p>
              <ul>
                <li><strong>Nom et logo</strong> — apparaissent sur tous les documents imprimés</li>
                <li><strong>Devise</strong> — utilisée dans tous les calculs et états</li>
                <li><strong>Exercice en cours</strong> — période comptable active</li>
                <li><strong>Taux de taxation</strong> — appliqué automatiquement aux factures</li>
              </ul>
            </div>

            <div class="step-card">
              <div class="card-head"><h5><i class="fa fa-check-circle" style="color:#0665aa"></i> Circuit de validation</h5></div>
              <p>Définissez les étapes d'approbation pour les opérations sensibles (sinistres, ententes préalables, règlements) :</p>
              <ol>
                <li>Créer une étape avec un libellé et un rôle validateur</li>
                <li>Définir l'ordre d'exécution (niveau 1, 2, 3…)</li>
                <li>Activer le circuit — toute opération concernée devra passer par ces étapes</li>
              </ol>
            </div>

            <span class="section-tag"><i class="fa fa-briefcase"></i> Paramètres Production</span>

            <div class="feature-grid">
              <div class="feature-card">
                <div class="fc-icon"><i class="fa fa-file-alt"></i></div>
                <div class="fc-body">
                  <h6>Polices</h6>
                  <p>Créez les types de polices : individuelle, collective, famille. Définissez les périodes de couverture et les options.</p>
                </div>
              </div>
              <div class="feature-card">
                <div class="fc-icon"><i class="fa fa-table"></i></div>
                <div class="fc-body">
                  <h6>Barèmes</h6>
                  <p>Grilles de remboursement par acte médical et par garantie. Chaque garantie (hospit., optique…) a son propre barème.</p>
                </div>
              </div>
              <div class="feature-card">
                <div class="fc-icon"><i class="fa fa-credit-card"></i></div>
                <div class="fc-body">
                  <h6>Modes de règlement</h6>
                  <p>Espèces, chèque, virement, mobile money. Le mode CRÉDIT est réservé au système (compensation interne).</p>
                </div>
              </div>
              <div class="feature-card">
                <div class="fc-icon"><i class="fa fa-university"></i></div>
                <div class="fc-body">
                  <h6>Banques</h6>
                  <p>Référencer les banques pour les chèques et virements. Nécessaire pour l'impression des chèques.</p>
                </div>
              </div>
            </div>

            <span class="section-tag"><i class="fa fa-heartbeat"></i> Paramètres Médical</span>

            <div class="step-card">
              <div class="card-head"><h5><i class="fa fa-stethoscope" style="color:#0665aa"></i> Actes médicaux</h5></div>
              <p>Définissez la liste des actes remboursables avec leur code (nomenclature) et tarif de référence. Ces actes sont utilisés lors de la saisie RD et du tiers payant.</p>
            </div>

            <div class="step-card">
              <div class="card-head"><h5><i class="fa fa-hospital" style="color:#0665aa"></i> Prestataires de soins</h5></div>
              <ol>
                <li>Saisir le nom, le type (clinique, pharmacie, laboratoire…) et les coordonnées</li>
                <li>Définir si le prestataire est en réseau (tiers payant autorisé)</li>
                <li>Associer les spécialités médicales disponibles</li>
              </ol>
            </div>
          </div>

          <!-- ════════════════ PRODUCTION ════════════════ -->
          <div *ngIf="activeSection === 'production'">
            <h1 class="page-title">Production</h1>
            <p class="page-subtitle">Gestion des contrats, des bénéficiaires et des quittances de prime.</p>

            <div class="step-card">
              <div class="card-head"><div class="step-num">1</div><h5>Créer un contrat</h5></div>
              <div class="workflow" style="margin-top:10px; margin-bottom:0">
                <div class="wf-step">
                  <div class="wf-num" style="background:#6c757d; width:20px; height:20px; font-size:10px">a</div>
                  <div class="wf-body"><h6>Aller dans Production › Contrat › Nouveau</h6><p>Renseigner le souscripteur, le garant et la police souhaitée.</p></div>
                </div>
                <div class="wf-step">
                  <div class="wf-num" style="background:#6c757d; width:20px; height:20px; font-size:10px">b</div>
                  <div class="wf-body"><h6>Définir la période de couverture</h6><p>Date de début, date de fin, type de renouvellement (annuel, mensuel).</p></div>
                </div>
                <div class="wf-step">
                  <div class="wf-num" style="background:#6c757d; width:20px; height:20px; font-size:10px">c</div>
                  <div class="wf-body"><h6>Choisir les garanties</h6><p>Sélectionner les garanties incluses (hospit., pharmacie, optique…) et leurs plafonds.</p></div>
                </div>
                <div class="wf-step">
                  <div class="wf-num" style="background:#6c757d; width:20px; height:20px; font-size:10px">d</div>
                  <div class="wf-body"><h6>Valider et soumettre</h6><p>Le contrat passe en statut « En attente de validation » selon le circuit configuré.</p></div>
                </div>
              </div>
            </div>

            <div class="step-card">
              <div class="card-head"><div class="step-num">2</div><h5>Ajouter des bénéficiaires</h5></div>
              <p><strong>Ajout individuel :</strong> Production › Info bénéficiaire › Nouveau. Renseignez le nom, prénom, date de naissance, N° carte et le collège.</p>
              <p><strong>Import en masse :</strong></p>
              <ol>
                <li>Cliquer sur <strong>Import Excel</strong></li>
                <li>Télécharger le modèle fourni par le système</li>
                <li>Remplir le fichier en respectant les colonnes obligatoires</li>
                <li>Importer — les erreurs de format sont signalées ligne par ligne</li>
              </ol>
              <div class="callout info" style="margin-top:10px; margin-bottom:0">
                <i class="fa fa-info-circle callout-icon"></i>
                <p>Chaque bénéficiaire reçoit automatiquement un numéro de carte unique. Les cartes peuvent être imprimées depuis ce module.</p>
              </div>
            </div>

            <div class="step-card">
              <div class="card-head"><div class="step-num">3</div><h5>Émettre une quittance de prime</h5></div>
              <ol>
                <li>Aller dans <strong>Production › Quittance › Émettre quittance</strong></li>
                <li>Sélectionner la police et la période de facturation</li>
                <li>Le système calcule automatiquement la prime TTC selon le barème et l'effectif</li>
                <li>Vérifier le montant et valider l'émission</li>
                <li>La quittance devient disponible pour encaissement dans la Comptabilité</li>
              </ol>
            </div>

            <div class="step-card">
              <div class="card-head"><div class="step-num">4</div><h5>Facturer le garant</h5></div>
              <p>Après validation des décomptes de sinistres, groupez-les en une facture garant via <strong>Production › Facturer garant</strong>. La facture est ensuite encaissée dans la Comptabilité.</p>
            </div>

            <div class="step-card">
              <div class="card-head"><div class="step-num">5</div><h5>Renouvellement de contrat</h5></div>
              <p>À l'expiration d'un contrat, utilisez <strong>Production › Renouvellement contrat</strong> pour générer automatiquement la nouvelle période avec les mêmes paramètres, éventuellement ajustés.</p>
            </div>
          </div>

          <!-- ════════════════ PRESTATION ════════════════ -->
          <div *ngIf="activeSection === 'prestation'">
            <h1 class="page-title">Prestation</h1>
            <p class="page-subtitle">Gestion des soins pris en charge via le tiers payant et la saisie des relevés de dépenses.</p>

            <div class="step-card">
              <div class="card-head"><h5><i class="fa fa-id-card" style="color:#0665aa"></i> Tiers payant — prise en charge directe</h5></div>
              <p>Le tiers payant permet au bénéficiaire de se soigner sans avancer les frais :</p>
              <div class="workflow" style="margin-top:10px; margin-bottom:0">
                <div class="wf-step">
                  <div class="wf-num" style="background:#6c757d; width:20px; height:20px; font-size:10px">1</div>
                  <div class="wf-body"><h6>Identifier le bénéficiaire</h6><p>Scanner la carte ou rechercher par nom / numéro d'assuré.</p></div>
                </div>
                <div class="wf-step">
                  <div class="wf-num" style="background:#6c757d; width:20px; height:20px; font-size:10px">2</div>
                  <div class="wf-body"><h6>Vérifier les droits</h6><p>Le système affiche les garanties actives, les plafonds restants et les éventuelles exclusions.</p></div>
                </div>
                <div class="wf-step">
                  <div class="wf-num" style="background:#6c757d; width:20px; height:20px; font-size:10px">3</div>
                  <div class="wf-body"><h6>Saisir l'acte</h6><p>Sélectionner l'acte dans le référentiel, indiquer le montant facturé par le prestataire.</p></div>
                </div>
                <div class="wf-step">
                  <div class="wf-num" style="background:#6c757d; width:20px; height:20px; font-size:10px">4</div>
                  <div class="wf-body"><h6>Valider</h6><p>Le système calcule la part prise en charge et la part restant à la charge du bénéficiaire.</p></div>
                </div>
              </div>
            </div>

            <div class="step-card">
              <div class="card-head"><h5><i class="fa fa-clipboard-list" style="color:#0665aa"></i> Saisie RD — Relevé de Dépenses</h5></div>
              <p>La saisie RD enregistre les actes pour remboursement ultérieur au prestataire. Choisissez la spécialité correspondante :</p>
              <table class="manual-table" style="margin-top:8px">
                <thead><tr><th>Spécialité</th><th>Actes typiques</th></tr></thead>
                <tbody>
                  <tr><td>Consultation</td><td>Consultation générale ou spécialisée</td></tr>
                  <tr><td>Pharmacie / Ordonnance</td><td>Médicaments prescrits</td></tr>
                  <tr><td>Hospitalisation</td><td>Séjour hospitalier, frais de chambre</td></tr>
                  <tr><td>Laboratoire</td><td>Analyses biologiques</td></tr>
                  <tr><td>Imagerie</td><td>Radio, scanner, IRM, échographie</td></tr>
                  <tr><td>Optique</td><td>Lunettes, lentilles</td></tr>
                  <tr><td>Dentaire</td><td>Soins dentaires, prothèses</td></tr>
                  <tr><td>Kinésithérapie</td><td>Séances de rééducation</td></tr>
                  <tr><td>Maternité</td><td>Suivi grossesse, accouchement</td></tr>
                </tbody>
              </table>
              <div class="callout warning" style="margin-top:12px; margin-bottom:0">
                <i class="fa fa-exclamation-triangle callout-icon"></i>
                <p>Vérifiez toujours les <strong>plafonds annuels</strong> restants et les <strong>actes soumis à entente préalable</strong> avant validation.</p>
              </div>
            </div>
          </div>

          <!-- ════════════════ MÉDICAL ════════════════ -->
          <div *ngIf="activeSection === 'medical'">
            <h1 class="page-title">Médical</h1>
            <p class="page-subtitle">Gestion des autorisations médicales, des hospitalisations et du suivi médical.</p>

            <div class="step-card">
              <div class="card-head"><h5><i class="fa fa-file-medical" style="color:#0665aa"></i> Entente préalable</h5></div>
              <p>Certains actes coûteux nécessitent une autorisation du médecin conseil avant leur réalisation :</p>
              <ol>
                <li>Le gestionnaire crée une demande en saisissant l'acte, le prestataire et le devis</li>
                <li>Le médecin conseil reçoit la demande et l'instruit</li>
                <li>Décisions possibles : <strong>Accord total</strong>, <strong>Accord partiel</strong> (avec montant plafonné) ou <strong>Refus motivé</strong></li>
                <li>Le bénéficiaire et le prestataire sont notifiés de la décision</li>
              </ol>
              <div class="callout info" style="margin-top:10px; margin-bottom:0">
                <i class="fa fa-clock callout-icon"></i>
                <p>Le délai de réponse légal est généralement de 48 à 72h. Au-delà, l'accord est réputé tacite selon la configuration.</p>
              </div>
            </div>

            <div class="step-card">
              <div class="card-head"><h5><i class="fa fa-hospital" style="color:#0665aa"></i> Demande d'hospitalisation</h5></div>
              <ol>
                <li>Soumettre la demande avec le diagnostic, la durée prévisionnelle et l'établissement</li>
                <li>Le médecin conseil valide et fixe le forfait journalier pris en charge</li>
                <li>Lors de la sortie, le décompte final est établi sur la base du séjour réel</li>
              </ol>
            </div>

            <div class="step-card">
              <div class="card-head"><h5><i class="fa fa-pills" style="color:#0665aa"></i> Renouvellement bon médicament</h5></div>
              <p>Pour les patients sous traitement chronique (hypertension, diabète…) : renouvelez les bons sans nouvelle consultation, dans la limite des plafonds annuels.</p>
            </div>

            <div class="step-card">
              <div class="card-head"><h5><i class="fa fa-tasks" style="color:#0665aa"></i> Traitement RD</h5></div>
              <p>Validez ou rejetez les relevés de dépenses soumis par les prestataires. Les RD validés sont automatiquement transmis au module Comptabilité pour règlement.</p>
            </div>
          </div>

          <!-- ════════════════ SINISTRE ════════════════ -->
          <div *ngIf="activeSection === 'sinistre'">
            <h1 class="page-title">Sinistre</h1>
            <p class="page-subtitle">Déclaration, instruction et règlement des sinistres médicaux.</p>

            <div class="step-card">
              <div class="card-head"><div class="step-num">1</div><h5>Créer un décompte de sinistre</h5></div>
              <ol>
                <li>Aller dans <strong>Sinistre › Décompte › Nouveau</strong></li>
                <li>Identifier le bénéficiaire et vérifier ses droits</li>
                <li>Sélectionner les actes réalisés et les montants facturés</li>
                <li>Appliquer les règles du barème (franchise, plafond, taux)</li>
                <li>Joindre les justificatifs scannés (ordonnances, factures, certificats)</li>
                <li>Soumettre pour validation</li>
              </ol>
            </div>

            <div class="step-card">
              <div class="card-head"><div class="step-num">2</div><h5>Validation du décompte</h5></div>
              <p>Le validateur (médecin conseil ou responsable sinistre) examine le dossier :</p>
              <table class="manual-table" style="margin-top:8px">
                <thead><tr><th>Décision</th><th>Effet</th></tr></thead>
                <tbody>
                  <tr><td><span style="color:#28a745"><strong>Approuver</strong></span></td><td>Le décompte génère une facture garant et passe au règlement</td></tr>
                  <tr><td><span style="color:#ffc107"><strong>Complément</strong></span></td><td>Retour au gestionnaire avec demande de pièce justificative</td></tr>
                  <tr><td><span style="color:#dc3545"><strong>Rejeter</strong></span></td><td>Clôture du dossier avec motif (exclusion, plafond atteint…)</td></tr>
                </tbody>
              </table>
            </div>

            <div class="callout success">
              <i class="fa fa-check-circle callout-icon"></i>
              <p>Après approbation, la facture garant correspondante est automatiquement créée dans le module Production › Facturer garant.</p>
            </div>
          </div>

          <!-- ════════════════ COMPTABILITÉ ════════════════ -->
          <div *ngIf="activeSection === 'comptabilite'">
            <h1 class="page-title">Comptabilité</h1>
            <p class="page-subtitle">Gestion des flux financiers : encaissements, comptes partenaires, ristournes et mouvements comptables.</p>

            <span class="section-tag"><i class="fa fa-hand-holding-usd"></i> Encaissement</span>

            <div class="step-card">
              <div class="card-head"><h5><i class="fa fa-university" style="color:#0665aa"></i> Ventiler un encaissement</h5></div>
              <p>Disponible pour 3 types : <strong>Garant</strong>, <strong>Quittance souscripteur</strong> et <strong>Police</strong>.</p>
              <ol>
                <li>Sélectionner le partenaire (garant ou souscripteur)</li>
                <li>Saisir le montant encaissé</li>
                <li>Choisir le mode de règlement (chèque, virement, espèces…)</li>
                <li>Cliquer sur <strong>Ventiler</strong></li>
              </ol>
              <div class="callout info" style="margin-top:10px">
                <i class="fa fa-lightbulb-o callout-icon"></i>
                <p><strong>Règle de priorité :</strong> Si un crédit disponible existe, il est consommé <em>en premier</em> avant le nouveau versement. Le montant saisi peut être 0 si le crédit couvre la totalité.</p>
              </div>
              <div class="callout success" style="margin-bottom:0">
                <i class="fa fa-check callout-icon"></i>
                <p><strong>Surplus :</strong> Si le paiement dépasse les factures dues, le surplus est automatiquement mis en réserve comme crédit pour les prochaines échéances.</p>
              </div>
            </div>

            <span class="section-tag"><i class="fa fa-wallet"></i> Compte partenaire</span>

            <div class="step-card">
              <div class="card-head"><h5><i class="fa fa-list-alt" style="color:#0665aa"></i> Consulter le journal d'un partenaire</h5></div>
              <p>Le journal affiche toutes les entrées (crédits) et sorties (débits) avec :</p>
              <ul>
                <li>Date de l'opération</li>
                <li>Libellé de la transaction</li>
                <li>Montant crédit / débit</li>
                <li>Solde cumulé après chaque opération</li>
              </ul>
              <p>Filtrez par partenaire pour n'afficher que son historique.</p>
            </div>

            <div class="step-card">
              <div class="card-head"><h5><i class="fa fa-undo" style="color:#0665aa"></i> Ristourne — remboursement de crédit</h5></div>
              <p>Quand un partenaire dispose d'un crédit excédentaire (fin d'exercice, trop-perçu) :</p>
              <ol>
                <li>Cliquer sur <strong>Ristourner</strong> (bouton actif uniquement si solde > 0)</li>
                <li>Sélectionner le partenaire dans la liste</li>
                <li>Le système calcule et affiche le crédit disponible en temps réel</li>
                <li>Saisir le montant à rembourser (≤ crédit disponible)</li>
                <li>Indiquer un motif (optionnel)</li>
                <li>Confirmer — une écriture de débit est enregistrée dans le journal</li>
              </ol>
              <div class="callout warning" style="margin-top:10px; margin-bottom:0">
                <i class="fa fa-exclamation-triangle callout-icon"></i>
                <p>Le remboursement physique (chèque, virement) est préparé depuis <strong>Comptabilité › Factures comptables</strong> une fois la ristourne enregistrée.</p>
              </div>
            </div>

            <span class="section-tag"><i class="fa fa-exchange-alt"></i> Mouvements comptables</span>

            <div class="step-card">
              <div class="card-head"><h5><i class="fa fa-stream" style="color:#0665aa"></i> Comprendre les mouvements</h5></div>
              <p>Chaque opération génère automatiquement un ou plusieurs mouvements comptables :</p>
              <table class="manual-table" style="margin-top:8px">
                <thead><tr><th>Opération</th><th>Sens</th><th>Granularité</th></tr></thead>
                <tbody>
                  <tr><td>Encaissement (ventilation)</td><td><span style="color:#28a745"><strong>CRÉDIT</strong></span></td><td>1 ligne par facture réglée</td></tr>
                  <tr><td>Ristourne / Remboursement</td><td><span style="color:#dc3545"><strong>DÉBIT</strong></span></td><td>1 ligne par ristourne</td></tr>
                </tbody>
              </table>
              <p style="margin-top:8px">Pour les factures <strong>partiellement réglées</strong>, le mouvement indique le montant payé, le total de la facture, le reste à régler et le statut (PARTIEL / SOLDÉ).</p>
            </div>

            <div class="step-card">
              <div class="card-head"><h5><i class="fa fa-upload" style="color:#0665aa"></i> Déversement vers la comptabilité externe</h5></div>
              <p>Le déversement exporte les mouvements comptables vers votre logiciel de comptabilité (Sage, EBP, etc.) :</p>
              <ol>
                <li>Sélectionner la période à déverser</li>
                <li>Vérifier la liste des mouvements non encore déversés</li>
                <li>Lancer le déversement — un numéro de batch unique est attribué</li>
                <li>Les mouvements sont marqués comme déversés et ne peuvent plus être modifiés</li>
              </ol>
            </div>
          </div>

          <!-- ════════════════ ADMINISTRATION ════════════════ -->
          <div *ngIf="activeSection === 'administration'">
            <h1 class="page-title">Administration</h1>
            <p class="page-subtitle">Gestion des utilisateurs, des rôles et des habilitations d'accès.</p>

            <div class="callout danger">
              <i class="fa fa-lock callout-icon"></i>
              <p><strong>Accès restreint :</strong> Ce module est réservé aux administrateurs. Toute modification de rôle est irréversible sans intervention manuelle.</p>
            </div>

            <div class="step-card">
              <div class="card-head"><div class="step-num">1</div><h5>Créer un utilisateur</h5></div>
              <ol>
                <li>Administration › Utilisateurs › Nouveau</li>
                <li>Renseigner : nom, prénom, login, email, téléphone</li>
                <li>Assigner un <strong>rôle</strong> (détermine les menus accessibles)</li>
                <li>Associer à une <strong>filiale</strong></li>
                <li>Sauvegarder — l'utilisateur reçoit ses identifiants par email</li>
              </ol>
            </div>

            <div class="step-card">
              <div class="card-head"><div class="step-num">2</div><h5>Gérer les rôles et habilitations</h5></div>
              <p>Un rôle est un ensemble de <strong>fonctionnalités autorisées</strong> (codifications). L'interface affiche l'arborescence complète des menus :</p>
              <ul>
                <li>Cocher une fonctionnalité pour l'activer dans ce rôle</li>
                <li>Décocher pour la retirer</li>
                <li>Les modifications s'appliquent à la <strong>prochaine connexion</strong> des utilisateurs concernés</li>
              </ul>
            </div>

            <div class="step-card">
              <div class="card-head"><div class="step-num">3</div><h5>Autres types d'utilisateurs</h5></div>
              <table class="manual-table" style="margin-top:8px">
                <thead><tr><th>Type</th><th>Accès</th></tr></thead>
                <tbody>
                  <tr><td><strong>Utilisateurs prestataires</strong></td><td>Accès limité au portail prestataire (saisie RD, suivi dossiers)</td></tr>
                  <tr><td><strong>Utilisateurs garants</strong></td><td>Accès consultation : factures, décomptes, balance agée</td></tr>
                  <tr><td><strong>Utilisateurs bénéficiaires</strong></td><td>Accès portail assuré : droits, historique remboursements</td></tr>
                </tbody>
              </table>
            </div>

            <div class="step-card">
              <div class="card-head"><div class="step-num">4</div><h5>Circuit de validation</h5></div>
              <p>Configurez qui peut approuver quoi :</p>
              <ul>
                <li>Définir les étapes de validation pour les sinistres, ententes préalables et règlements</li>
                <li>Chaque étape est associée à un rôle et à un niveau d'approbation</li>
                <li>Un dossier bloqué à une étape notifie automatiquement le validateur</li>
              </ul>
            </div>
          </div>

          <!-- ════════════════ ÉDITIQUE ════════════════ -->
          <div *ngIf="activeSection === 'editique'">
            <h1 class="page-title">Éditique & Rapports</h1>
            <p class="page-subtitle">Génération des états financiers, statistiques et documents imprimables.</p>

            <div class="feature-grid">
              <div class="feature-card">
                <div class="fc-icon"><i class="fa fa-building"></i></div>
                <div class="fc-body">
                  <h6>Récapitulatif compagnie</h6>
                  <p>Vue d'ensemble : primes émises, sinistres réglés, taux de sinistralité par période.</p>
                </div>
              </div>
              <div class="feature-card">
                <div class="fc-icon"><i class="fa fa-chart-line"></i></div>
                <div class="fc-body">
                  <h6>Résultats techniques</h6>
                  <p>Rentabilité par police, garant et exercice. Charges, commissions, résultat net.</p>
                </div>
              </div>
              <div class="feature-card">
                <div class="fc-icon"><i class="fa fa-receipt"></i></div>
                <div class="fc-body">
                  <h6>Fiche prime</h6>
                  <p>Détail des primes par bénéficiaire et par période. Utile pour les audits.</p>
                </div>
              </div>
              <div class="feature-card">
                <div class="fc-icon"><i class="fa fa-file-medical-alt"></i></div>
                <div class="fc-body">
                  <h6>État des dépenses</h6>
                  <p>Toutes les dépenses par bénéficiaire, acte et prestataire. Exportable Excel.</p>
                </div>
              </div>
              <div class="feature-card">
                <div class="fc-icon"><i class="fa fa-history"></i></div>
                <div class="fc-body">
                  <h6>Historique des éditions</h6>
                  <p>Tous les documents générés (PDF, Excel) archivés avec date et utilisateur.</p>
                </div>
              </div>
            </div>

            <div class="step-card">
              <div class="card-head"><h5><i class="fa fa-cogs" style="color:#0665aa"></i> Générer un rapport</h5></div>
              <ol>
                <li>Choisir le type de rapport dans le menu Éditique</li>
                <li>Sélectionner la <strong>période</strong> (date début — date fin)</li>
                <li>Appliquer les filtres : garant, souscripteur, police (optionnel)</li>
                <li>Cliquer sur <strong>Générer PDF</strong> ou <strong>Exporter Excel</strong></li>
                <li>Le fichier est téléchargeable et archivé dans l'historique</li>
              </ol>
              <div class="callout info" style="margin-top:10px; margin-bottom:0">
                <i class="fa fa-history callout-icon"></i>
                <p>Retrouvez tous les documents générés dans <strong>Éditique › Historique des éditions</strong>, avec possibilité de re-télécharger à tout moment.</p>
              </div>
            </div>
          </div>

          <!-- ════════════════ FAQ ════════════════ -->
          <div *ngIf="activeSection === 'faq'">
            <h1 class="page-title">Questions fréquentes</h1>
            <p class="page-subtitle">Les réponses aux questions les plus courantes des utilisateurs.</p>

            <div class="faq-item" *ngFor="let item of faq; let i = index">
              <div class="faq-question" [class.open]="openFaq === i" (click)="toggleFaq(i)">
                <span>{{ item.q }}</span>
                <i class="fa fa-chevron-right"></i>
              </div>
              <div class="faq-answer" *ngIf="openFaq === i">
                {{ item.a }}
              </div>
            </div>

            <div class="callout info" style="margin-top:20px">
              <i class="fa fa-envelope callout-icon"></i>
              <p>Vous ne trouvez pas votre réponse ? Contactez votre administrateur ou l'équipe support Medicalee.</p>
            </div>
          </div>

          <!-- ════════════════ GLOSSAIRE ════════════════ -->
          <div *ngIf="activeSection === 'glossaire'">
            <h1 class="page-title">Glossaire</h1>
            <p class="page-subtitle">Définitions des termes techniques utilisés dans Medicalee.</p>

            <div class="glossaire-grid">
              <div class="glossaire-item" *ngFor="let g of glossaire">
                <div class="terme">{{ g.terme }}</div>
                <div class="def">{{ g.def }}</div>
              </div>
            </div>
          </div>

        </div><!-- /manuel-content -->
      </div><!-- /manuel-wrapper -->
    </div>
  </div>
</section>
